import { Flex } from '@grupoboticario/flora-react';

import { FeatureFlag } from 'domains/feature-flag.d';
import { useFeatureFlag, useResellerRegistration } from 'hooks';
import { ItemsAccordion } from 'pages/Profile/components/ItemsAccordion';

import Styles from './MessageChanged.styles';

export const MessageChanged = () => {
  const {
    data: registration,
    isLoading: isLoadingRegistration,
    isError,
  } = useResellerRegistration();

  const isEnabledCadastralChange = useFeatureFlag(FeatureFlag.ENABLE_CADASTRAL_CHANGE_PHONE, false)
    .value as string;

  const showPhoneRegistration =
    isEnabledCadastralChange && !isError && !isLoadingRegistration && registration?.phone;

  const isShowPhoneDivider = registration?.phone?.message && registration?.phone.statusMessage;

  if (!showPhoneRegistration) {
    return null;
  }

  return (
    <Flex direction='column'>
      <ItemsAccordion items={registration?.phone} />
      {isShowPhoneDivider && <Styles.Divider variant='Line' />}
    </Flex>
  );
};
